import { Fish, Crown, Anchor, Wheat, Star, Lock, Sun, Heart, Waves, Shield, Flame, Sparkles } from "lucide-react";

const ICONS: Record<string, any> = { fish: Fish, crown: Crown, anchor: Anchor, wheat: Wheat, star: Star, sun: Sun, heart: Heart, waves: Waves, shield: Shield, flame: Flame, sparkles: Sparkles };

export function SeriesBadge({ badge, size = 112 }: { badge: any; size?: number }) {
  const Icon = ICONS[badge.icon] || Star;
  const on = badge.earned;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size * 1.18 }} data-testid={`series-badge-${badge.series_id || badge.name}`} data-earned={on}>
      <div className="absolute bottom-0 left-1/2 flex -translate-x-1/2 gap-1" style={{ width: size * 0.5 }}>
        <span className="h-0 flex-1 border-x-[10px] border-t-[26px] border-x-transparent" style={{ borderTopColor: on ? badge.color : "#CBD5E1" }} />
        <span className="h-0 flex-1 border-x-[10px] border-t-[26px] border-x-transparent" style={{ borderTopColor: on ? badge.color : "#CBD5E1", filter: "brightness(0.85)" }} />
      </div>
      <div className={`absolute left-0 top-0 flex items-center justify-center rounded-full border-[5px] ${on ? "border-amber-300 shadow-xl" : "border-dashed border-slate-300"}`}
        style={{ width: size, height: size, background: on ? `radial-gradient(circle at 30% 30%, #fff8, transparent 60%), ${badge.color}` : "#F1F5F9" }}>
        {on ? <Icon className="text-white drop-shadow" style={{ width: size * 0.42, height: size * 0.42 }} /> : <Lock className="text-slate-400" style={{ width: size * 0.28, height: size * 0.28 }} />}
      </div>
    </div>
  );
}
